<template>
   <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row class="pa-5" justify="center">
            <v-col cols="10" md="3" align-self="center">
              <ItemCard
                  :item="data"
                  :title="userName"
                  :subtitle="data.rank ? (roleName + ', ' + $t('common:rank') + ' ' + data.rank) : roleName"
                  :description="facilityName"
                  hideActionBtn1
                  hideActionBtn2
                  hideActionBtn3
                  hideChart
                  hideViewBtn
              />
            </v-col>
            <v-col cols="12" md="5">
              <h4 class="font-weight-bold">{{ $t('buttons:add-specific', { specific: $t('common:role')}) }}</h4>
              <v-row>
                <v-col cols="6" style="height: 86px;">
                  <UserTypeahead
                      ref="userTypeahead"
                      :value="data.users"
                      @input="setUserAndName($event)"
                      is-required
                      :label="$t('common:user')"
                      tabindex="14"
                      @onAddClick="registerNewUser($event)"
                  />
                </v-col>
                <v-col cols="6" align-self="center">
                  <v-btn outlined color="primary" route :to="`/${this.$store.state.manager.settingsModuleUrl}/profile/customer/users`" v-if="isMain">
                    <v-icon>add</v-icon>
                    <span class="d-none d-sm-block">{{ $t('book/building:building.user-assignment-dialog.add-user') }}</span>
                  </v-btn>
                </v-col>
              </v-row>

              <v-select
                  outlined
                  v-model="data.role"
                  :label="$t('common:role')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="restRoles"
                  item-text="name"
                  item-value="id"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  @change="setRoleName"
                  tabindex="15"
              />

              <v-text-field
                  outlined
                  v-model="data.rank"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  :label="$t('common:rank')"
                  type="number"
                  tabindex="16"
              />

              <v-select
                  outlined
                  v-model="data.facility"
                  :label="$t('common:facility')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="restFacilities"
                  item-text="name"
                  item-value="id"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  @change="setFacilityName"
                  tabindex="17"
              />

              <BaseButton
                  color="primary"
                  :btn-text="$t('buttons:add')"
                  @clickedButton="saveAssignment"
              />
              <DirtyConfirmButtonDialog
                    ref="cancelDialog"
                    :btn-text="$t('buttons:cancel')"
                    color="grey"
                    :dialog-title="$t('dialog:dirty-save-btn-title')"
                    :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="closeDialog()"
                    :dataToWatch="data"
                    hideOverlay
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

     <MinimizedUsersDialogForm @onRegistered="setRegisteredUser" ref="usersDialogForm"/>
   </v-dialog>
</template>
<script>
import FacilityUserAssignment from "@/modules/book/data/facility-user-assignment";
import WorkerRole from "@/modules/core/data/worker-role"
import Users from "@/modules/core/data/users";
import Facility from "@/modules/book/data/facility";

import WorkerRoleService from "@/modules/core/services/worker-role-service";
import UsersService from "@/modules/core/services/users-service";
import BuildingService from "@/modules/book/services/building-service";
import FacilityUserAssignmentService from "@/modules/book/services/facility-user-assignment-service";

import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import {ruleRequired} from "@/modules/core/services/rules";

import ItemCard from '@/modules/core/components/ItemCard';
import BaseButton from "@/modules/core/components/Base/BaseButton";

import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";

import {mapGetters} from 'vuex';
import UserTypeahead from "@/modules/core/components/UserTypeAhead";
import MinimizedUsersDialogForm from "@/modules/core/components/MinimizedUsersDialogForm";

export default {
  name: "BuildingUserAssignmentForm",
  components: {
    MinimizedUsersDialogForm,
    UserTypeahead,
    ItemCard,
    BaseButton,
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      dialog: false,
      data: new FacilityUserAssignment(),
      restUsers: [],
      restRoles: [],
      restFacilities: [],
      userName: '',
      roleName: '',
      facilityName: '',
      tableOptions: [],
      tableSearch: []
    }
  },
  methods: {
    ruleRequired,
    setUsername(item) {
      for(var i = 0; i < this.restUsers.length; i++) {
        if(this.restUsers[i].id == item) {
          this.userName = this.restUsers[i].name;
        }
      }
    },
    setRoleName(item) {
      for(var i = 0; i < this.restRoles.length; i++) {
        if(this.restRoles[i].id == item) {
          this.roleName = this.restRoles[i].name;
        }
      }
    },
    setFacilityName(item) {
      for(var i = 0; i < this.restFacilities.length; i++) {
        if(this.restFacilities[i].id == item) {
          this.facilityName = this.restFacilities[i].name;
        }
      }
    },

    // closes and resets card fields and form
    closeDialog() {
      this.dialog = false;
      this.userName = '';
      this.roleName = '';
      this.facilityName = '';
      this.$refs.form.reset();
      this.$refs.cancelDialog.startWatch();
    },

    saveAssignment() {
      if (!this.$refs.form.validate()) {
        Utils.showWarningSnackbar(this.$t('snackbar:empty-fields'))
        return;
      }

      FacilityUserAssignmentService.postToAPI(this.data,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:role')}));
          this.closeDialog();
          this.$emit('updateRoles', this.tableOptions, this.tableSearch);
        },
        (serviceName, error) => {
          if (error.response.headers.error_cause && this.$t('error_causes:' + error.response.headers.error_cause)) {
            Utils.showFailureSnackbar(this.$t("error-causes:" + error.response.headers.error_cause));
          } else {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:role')}))
          }

          this.$logger.error(serviceName + "Could not post facility user assignment because: " + error);
        }
      );
    },

    setUserAndName(user) {
      this.data.users = user;
      if (user) {
        this.setUsername(user)
      } else {
        this.userName = ''
      }
    },

    registerNewUser(name) {
      this.$refs.usersDialogForm.openDialogWithName(name);

      // reduce z-index of typeahead box
      document.getElementsByClassName('v-menu__content theme--light v-menu__content--fixed menuable__content__active v-autocomplete__content')[0].style.zIndex = 400;
    },

    setRegisteredUser(item) {
      this.restUsers.push(item);
      this.$refs.userTypeahead.initWithoutFetch(item);
    },

    openDialog(options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.dialog = true;
    }
  },
  computed: {
    ...mapGetters('auth', ['isMain']),
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    }
  },
  created() {
    WorkerRoleService.readAllFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToObjectArray(resp.data, WorkerRole);
        if (response == null) {
          this.$router.go(-1);
        } else {
          this.restRoles = response;
        }
      },
      (error) => {
        this.$logger.error(error);
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:role_plural')}))
      }
    )

    UsersService.readAllFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToObjectArray(resp.data, Users);
        if (response == null) {
          this.$router.go(-1);
        } else {
          this.restUsers = response;
          this.loadingDialog = false;
        }
      },
      (error) => {
        this.$logger.error(error);
        this.loadingDialog = false;
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}))
      }
    )

    BuildingService.readFacilitiesForBuilding(this.$route.params.id,
      (res) => {
        this.restFacilities = DataUtils.parseDataToObjectArray(res.data, Facility);
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility_plural')}))
        this.$logger.error(error);
      }
    )
  },
  mounted() {
    this.$refs.cancelDialog.startWatch();
  }
}
</script>
<style lang="scss">
.v-overlay.v-overlay--active.theme--dark{
  z-index: 300!important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 405!important;
}
</style>


